<template>
  <div
    class="board"
   
  >
    <div class="sks"><span @click="gos">
        ＜ </span>
      购买鲸会员
    </div>
    <img src="../../assets/my/vip1.jpg" alt="">
    <div class="nei">
      <div class="tou">会员须知</div>
      <p>1、您的账号必须已经平台认证通过；</p>
      <p>2、您已经仔细阅读并完全理解同意了《货空间鲸会员协议》的各项条款及内容；
</p>
<p>  
3、只能线上支付、线上开通，不接受线下付款；

</p>
<p>
4、会员资格有效期内所下订单结清货款后才对实际成交商品按我方规定比例计算返利；后期若发生退货或退款时，亦会同步扣减返利；

</p>
<p>
5、具体返利比例将因商品不同而异，且会因我方经营策略的调整而调整；

</p>
<p>
6、会员取得的返利用于新订单结算时的最大比例为不超过单笔订单货物总金额的15%；

</p>
<p>
7、鲸会员是平台提供的一项增值服务，一经购买开通，则概不退换返还；
</p>
<p>
 8、更多业务细节及规则详见《货空间鲸会员协议》；上海货空间拥有对鲸点返利业务规则及金额数据的最终决定权和解释权。

</p>
<div @click="maix" class="but">点击支付 : ￥2999.00/年</div>
    <div class="que">
        <van-checkbox  shape="square" v-model="checked">我已阅读、理解并同意<span @click.stop="gox" class="huang">《货空间鲸会员用户协议》</span></van-checkbox>
    </div>
    </div>
    <!-- <div class="divform" v-html="js"></div> -->
    <!-- <div class="wan">
        更多权益请关注货空间APP
    </div> -->
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }" >
      <div class=" fk" @click="mai1">
        <img src="../../assets/wechat@2x.png" alt="">
        <p>微信支付</p>
      </div>
       <div class=" fk" @click="mai">
        <img src="../../assets/wweds.png" alt="">

        <p>支付宝支付</p>
      </div>
     
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Dialog , Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast , Checkbox, CheckboxGroup} from 'vant'

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true })
  .use(NoticeBar)
  .use(Grid)
  .use(GridItem).use(Popup).use(Button).use( Checkbox).use( CheckboxGroup).use(Dialog)
import jsBridge from '../../config/jsbridge-mini.js'

export default {
  name: 'board',
  data () {
    return {
      checked:false,
      js:'',
      show:false,
      txt:''

    }
  },
  props: {
  },
  computed: {

  },
  watch: {

  },
  created () {

  
    var that = this
  // that.txt=JSON.parse(localStorage.getItem('city1')).id
jsBridge.onAppEnterForeground(function(){
  if(that.$route.name=='opvip2'){
 Dialog.confirm({
  title: '',
  message: '您是否已付款？',
  confirmButtonText:'已付',
  cancelButtonText:'未付'
})
  .then(() => {
    // on confirm
  location.href='https://nm.huokongjian.net/#/my'

  })
  .catch(() => {
    // on cancel
  })
  }
})
 
  },
  mounted () {

  },
  methods: {
    gos () {
      this.$router.go(-1)
    },
    gox(){
             this.$router.push("agreement2")

    },
    go1(){
     location.href='https://www.yimenapp.com/doc/demo48.cshtml'

    },
    maix(){
      if(this.checked){
      this.show=true

      }else{
            Toast('请先阅读同意鲸会员协议！')

      }
    },
    mai(){
      // location.href='https://www.yimenapp.com/doc/demo48.cshtml'
      // return
        if(this.checked){
            this.axios.post('aliorderstring', { }).then(res => {
               if(res.data.code!=200){
            Toast(res.data.msg)
            return
          }
                let red= res.data.orderStr
      jsBridge.aliPay({
orderString:red
}, function (succ, text) {
  if (succ) {
  location.href='https://nm.huokongjian.net/#/over'
  } else {    
    
  }
})
      }).catch()
  

        }else{
            Toast('请先阅读同意鲸会员协议！')
        }
    },
    mai1(){
 
        if(this.checked){
      // this.$router.push("over")
      this.axios.post('wxgetinfo', { }).then(res => {
       console.log(res)
          if(res.data.code!=200){
            Toast(res.data.msg)
            return
          }
       jsBridge.wxPay({
  //微信应用ID
  appid : res.data.info.appid,
  //商户号
  partnerid: res.data.info.partnerid,
  //预支付交易会话ID
  prepayid :res.data.info.prepayid ,
  //扩展字段
  package  :res.data.info.package,
  //随机字符串
  noncestr : res.data.info.noncestr,
  //时间戳（单位是秒，不是毫秒，切记）
  timestamp: res.data.info.timestamp,
  //签名
  sign     : res.data.info.sign 
}, function (succ, text) {
  let a= JSON.parse(text).errCode

    if(a==0){
        location.href='https://nm.huokongjian.net/#/over'

    }


  
});
      }).catch()

        }else{
            Toast('请先阅读同意鲸会员协议！')
        }
    },
    getProductList () {

    },
    getClassList () {

    },
  },

  destroyed () { },
  updated () { },
  components: {},
}
</script>


<style lang="less" scoped>
.board{
    padding-top: 1.2rem;
}
.fk{
  
      height: 1.92rem;
      border-bottom: 1px solid #ccc;
      padding: 0.3rem;
      .fan{
        float: left;
        padding: 0.3rem;
      }
      img {
        width: 1.1rem;
        height: 1.1rem;
        display: block;
        float: left;
        // background-color: #f99;
      }
      p {
        float: left;
        // width: 100%;
        font-size: 0.426667rem;
        line-height: 1.3rem;
        padding-left: 0.5rem;
        span{
          
        }
      }
      .p2{
        line-height: 0.65rem;
        font-size: 0.4rem;
        // padding-right: 0.2rem;
        text-align: right;
        float: right;
      }
    
}
.sks {
  width: 100%;
  z-index: 99;
  height: 1.2rem;
  background-color: #fff;
  text-align: center;
  font-size: 0.4rem;
  line-height: 1.2rem;
  position: fixed;
  top: 0;
  left: 0;
  //   margin-top: 0.5rem;
  // position: fixed;
  // top: 0;
  // z-index: 99;
  // width: 100%;
  span {
    width: 1rem;
    position: absolute;
    left: 0;
    font-size: 0.5rem;
  }
}
.but{
    width: 100%;
    height: 1.5rem;
    margin: 0 auto;
    line-height: 1.5rem;
    font-size: 0.4rem;
    text-align: center;
     background: url(../../assets/my/but.png) no-repeat center;
   background-size: 100% 100%;
   margin-bottom: 0.2rem;
}
.nei{
  height: 14rem;
   background: url(../../assets/my/di.png) no-repeat center;
   background-size: 104% 100%;
   padding:1rem 1rem 0 0.9rem;
   .tou{
    font-weight: 530;
    font-size: 0.36rem;
    border: 1px solid #2d334b;
    border-radius: 0.25rem;
    padding: 0 0.2rem;
    width: 2rem;
   }
   p{
    padding: 0.2rem 0;
   }
}
.que{
    
    text-align: center;
    padding-left:2%;
    .huang{
        color: #ecb47e;
    }
}
.wan{
    width: 80%;
    margin: 0 auto;
    height: 1.5rem,;
    line-height: 1.5rem;
    font-size: 0.4rem;
    color: #fff;
    background-color: #2d334b;
    border-radius: 0.5rem;
    text-align: center;
    margin-top: 1rem;
    position: fixed;
    bottom: 0.5rem;
    left: 10%;
}

</style>
